import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { verifyEmail } from '../api/auth';
import { useAuth } from '../hooks/useAuth';
import { BackgroundCanvas } from '../components/BackgroundCanvas';

type Status = 'loading' | 'success' | 'error';

export const VerifyPage: React.FC = () => {
  const { t } = useTranslation();
  const { token }            = useParams<{ token: string }>();
  const navigate             = useNavigate();
  const { token: authToken } = useAuth();
  const [status, setStatus]   = useState<Status>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (authToken) { navigate('/dashboard'); return; }
    if (!token)    { setStatus('error'); setMessage(t('verify.invalidLink')); return; }

    verifyEmail(token)
      .then((res) => {
        setStatus('success');
        setMessage(res.data.message || '');
        setTimeout(() => navigate('/login'), 3000);
      })
      .catch((err) => {
        setStatus('error');
        setMessage(err.response?.data?.error || t('verify.confirmError'));
      });
  }, [token, authToken, navigate]); // eslint-disable-line

  return (
    <div className="auth-page">
      <BackgroundCanvas opacity={0.3} />

      <div className="term-panel">
        <div className="term-panel__bar">
          <span className="term-panel__bar-dot" />
          <span className="term-panel__bar-dot" />
          <span className="term-panel__bar-dot" />
          <span className="term-panel__bar-title">{t('verify.termTitle')}</span>
        </div>

        <div className="term-panel__body">
          <div className="verify-status">

            {status === 'loading' && (
              <>
                <span className="verify-status__loader">_</span>
                <h2 className="verify-status__heading">{t('verify.verifying')}</h2>
                <p className="verify-status__text">{t('verify.pleaseWait')}</p>
              </>
            )}

            {status === 'success' && (
              <>
                <span className="verify-status__icon px-success">✓</span>
                <h2 className="verify-status__heading px-success">{t('verify.success')}</h2>
                {message && <p className="verify-status__text">{message}</p>}
                <p className="verify-status__text">{t('verify.redirecting')}</p>
                <Link to="/login" className="verify-status__link">{t('verify.signInNow')}</Link>
              </>
            )}

            {status === 'error' && (
              <>
                <span className="verify-status__icon px-error">✕</span>
                <h2 className="verify-status__heading px-error">{t('verify.error')}</h2>
                <p className="verify-status__text">{message}</p>
                <Link to="/" className="verify-status__link">{t('verify.backToMap')}</Link>
              </>
            )}

          </div>
        </div>
      </div>
    </div>
  );
};
